import deptMapping from "utils/mapping/dept"

const X_API_KEY = process.env.REACT_APP_X_API_KEY
async function getDept() {
  let result = [], itemsCount = 0, status = 0, error = null

  const uri = "https://phoenix.eng.psu.ac.th/personnel/api/get_dept"

  await fetch(uri, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      "x-api-key": X_API_KEY
    },
  })
    .then(resp => {      
      if (resp.status === 200) {
        status = 1
        return resp.json()
      } else {
        error = {
          code: resp.status,
          message: resp.statusText
        }
        return null
      }
    })
    .then(data => {
      if (data.length > 0) {
        result = data.map((value, index) => deptMapping(value, index))
        itemsCount = data.length
      }
    })
    .catch(fetchError => {
      error = fetchError
    });

  return {
    status,
    result,
    itemsCount,
    error
  }
}
export {
  getDept
}